import type { RefObject } from 'react';
import { useCallback, useEffect, useRef } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useSetBanditsCookie } from '#src/app/pages/psf/promoteOrShare/shared/hooks';

import { usePromoteFormState } from '../../../formContext';

type Result = ModelHookResult<
	{
		formRevealed: boolean;
		ref: RefObject<HTMLDivElement | null>;
	},
	{
		handlePromoteClick: () => void;
	}
>;

export function useContainer(): Result {
	const [{ promoteFormRevealed }, { setPromoteFormRevealed }] = usePromoteFormState();

	const track = useTracking();
	const setPsfComboBanditsCookie = useSetBanditsCookie();

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (promoteFormRevealed) {
			ref.current?.focus({ preventScroll: true });
		}
	}, [promoteFormRevealed]);

	return {
		data: {
			formRevealed: promoteFormRevealed,
			ref,
		},
		actions: {
			handlePromoteClick: useCallback(() => {
				setPsfComboBanditsCookie();
				void track('combo_psf_promote', {
					combo_promote_click_outcome: 'revealed',
				});
				setPromoteFormRevealed(true);
			}, [promoteFormRevealed, setPromoteFormRevealed, setPsfComboBanditsCookie, track]),
		},
	};
}
